import React, { useEffect, useState } from "react";
import styles from "./AddendumEditor.module.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import { ThreeCircles } from "react-loader-spinner";
import * as Icon from "react-bootstrap-icons";
import { AddendumEditorProps } from "./AddendumEditor.utils";
import EngagementApproverSetting from "../../../../engagement_letter/EngagementApproverSetting/EngagementApproverSetting";
import { EngagementApprover } from "../../../../engagement_letter/EngagementApproverSetting/EngagementApproverSetting.utils";
/**
 * AddendumEditor Component
 */
const AddendumEditor: React.FC<AddendumEditorProps> = ({
  sharedData, setSharedData, onValidationChange
}) => {
  const [allUsers, setAllUsers] = useState<EngagementApprover[]>([]);
  const [initialApprovers, setInitialApprovers] = useState<EngagementApprover[]>([]);
  const [selectedApprovers, setSelectedApprovers] = useState<EngagementApprover[]>([]);
  const [loading, setLoading] = useState(false);
  const [apiProgress, setApiProgress] = useState(false);
  const [approvalCheck, setApprovalCheck] = useState<boolean>(false);
  const [approvalRadio, setApprovalRadio] = useState<"Parallel" | "Sequential">(
    "Parallel"
  );
  const handleRadioChange = (event: any) => {
    setApprovalRadio(event.target.value);
  };

  const handleApprovalCheck = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setApprovalCheck(event.target.checked);
  };

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URI}/workflow/subscriptions/roles/users/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();
        setAllUsers(data.data || []);
      } catch (error) {
        toast.error("Failed to load users");
      }
    };

    fetchAllUsers();
  }, []);

  useEffect(() => {
    const fetchExistingApprovers = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const templateId = sharedData.templateId;
        let url = `${process.env.REACT_APP_BASE_URI}/mdm/engagement-letter/el_approvals/?TemplateId=${templateId}`

        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        if (data.data?.length > 0) {
          setSelectedApprovers(data.data);
          setInitialApprovers(data.data);
          setApprovalCheck(data.data[0].ApprovalRequired !== "Y");
          setApprovalRadio(data.data[0]?.ApprovalType);
        }
      } catch (err) {
        toast.error("Failed to load existing approvers");
      } finally {
        setLoading(false);
      }
    };

    fetchExistingApprovers();
  }, [sharedData.templateId]);

  return (
    <>
      {loading ? (
        <div className="flex-column-center-center">
          <ThreeCircles
            height="50"
            width="50"
            color="#4fa94d"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor="var(--theme1_tertiary)"
            innerCircleColor="var(--theme1_secondary)"
            middleCircleColor="var(--theme1_primary)"
          />
          <span>Loading your approval setting</span>
        </div>
      ) : (
        <div className={styles.approvalSettingWrapper}>
          <div className={styles.preferenceRadios}>
            <div className={styles.preferenceTitle}>Approval Preference</div>
            <div className={styles.preferenceInfo}>
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip id="button-tooltip">
                    Approval preference determines how client emails are sent:
                    Use "Sequential" to notify approvers one after another, or
                    "Parallel" to notify all at once.
                  </Tooltip>
                }
              >
                <Icon.PatchQuestion />
              </OverlayTrigger>
            </div>
          </div>
          <div className={styles.preferenceRadios}>
            <div>
              <input
                className={`form-check-input ${styles.preferenceRadio}`}
                type="radio"
                name="approvalPreference"
                id="send_for_approval_sequential"
                value="Sequential"
                checked={approvalRadio === "Sequential"}
                onChange={handleRadioChange}
              />
              <label
                className={styles.preferenceLabel}
                htmlFor="send_for_approval_sequential"
              >
                Sequential
              </label>
            </div>
            <div>
              <input
                className={`form-check-input ${styles.preferenceRadio}`}
                type="radio"
                name="approvalPreference"
                id="send_for_approval_parallel"
                value="Parallel"
                checked={approvalRadio === "Parallel"}
                onChange={handleRadioChange}
              />
              <label
                className={styles.preferenceLabel}
                htmlFor="send_for_approval_parallel"
              >
                Parallel
              </label>
            </div>
          </div>
          <div className={styles.approverCardContainer}>
            <EngagementApproverSetting
              allUsers={allUsers}
              selectedApprovers={selectedApprovers}
              setSelectedApprovers={setSelectedApprovers}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AddendumEditor;
